import React from "react";
import RecommendationEngineSection from "../../components/b2cComponents/RecommendationEngineSection";
import "./RecommendationEnginePage.scss";
const RecommendationDetailPage = ({isMobile}) => {
  return (
    <>
    <section className="recommed-wrapper">
      <RecommendationEngineSection isDetailPage={true} isMobile={isMobile}/>
      </section>
    </>
    
  );
};

export default RecommendationDetailPage;
